import * as types from "../types/userTypes";
import { initialUserState } from "../initialState";

export const auth = (state = initialUserState, action) => {
  switch (action.type) {
    case types.AUTH_CREATE_USER:
      return Object.assign({}, state, action.user);
    case types.AUTH_SIGNIN_USER:
      state.isAuthenticated = true;
      return Object.assign({}, state, action.user);
    case types.AUTH_LOGOUT_USER:
      if (localStorage.getItem('customerNumber') == "1158") {
        window.location.href = "https://snowlink.snowman.in/"
      }
      localStorage.clear();
      return initialUserState;
    default:
      return state;
  }
};
